import React from 'react'
import PropTypes from 'prop-types'

import { Box, Grid, Hidden, Paper } from '@material-ui/core'

import Image from 'artkive/components/Image'
import { TrackLink } from 'artkive/components/Tracker'
import { ABOUT_US } from 'artkive/constants/tracker/mainNavigation'

import { CardPadding, ColorFill, ContentCard, SectionWrapper } from './OtherProductsSection.style'

const OtherProductsSection = ({
  preview,
  img,
  text,
  href,
  linkText,
  trackerOptions,
  mirrored = false,
  colorIndex = 0,
}) => (
  <SectionWrapper>
    <Hidden smDown>
      <Grid container spacing={4} direction={mirrored ? 'row-reverse' : 'row'}>
        <Grid item xs={12} md={8}>
          <Image src={preview} />
        </Grid>
        <Grid item xs={false} md={4}>
          <ColorFill data-fill={colorIndex % 3}>&nbsp;</ColorFill>
        </Grid>
      </Grid>
    </Hidden>
    <ContentCard data-mirrored={mirrored || undefined}>
      <Paper elevation={0}>
        <CardPadding>
          <Box mb={2}>
            <TrackLink
              href={href}
              target='_blank'
              trackerEvent={ABOUT_US.OTHER_PROJECTS_CLICK}
              trackerOptions={trackerOptions}
            >
              {img}
            </TrackLink>
          </Box>
          <Box mb={4}>{text}</Box>
          <TrackLink
            href={href}
            target='_blank'
            trackerEvent={ABOUT_US.OTHER_PROJECTS_CLICK}
            trackerOptions={trackerOptions}
            underline='none'
            style={{ fontSize: '1rem', fontWeight: 600 }}
          >
            {linkText}
          </TrackLink>
        </CardPadding>
      </Paper>
    </ContentCard>
  </SectionWrapper>
)

OtherProductsSection.propTypes = {
  preview: PropTypes.string.isRequired,
  img: PropTypes.node.isRequired,
  text: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  trackerOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  mirrored: PropTypes.bool,
  colorIndex: PropTypes.number,
}

export default OtherProductsSection
